import Dialog from '@material-ui/core/Dialog';
import { useDirection } from '@hilma/netina2all';

import { Footer } from '../components';
import { useI18n } from '../hooks';
import { Button } from '.';

interface PopupProps {
	isOpen: boolean;
	imagePath: string;
	title: string;
	text?: string;
	button?: { text: string; onClick: Function };
}

const FullPagePopup: React.FC<PopupProps> = ({ isOpen, title, text = '', imagePath, button }) => {
	const direction = useDirection();
	const alts = useI18n(i18n => i18n.alts);

	const imagePathsAndAlts = {
		'/lulav-icons/add-heart.svg': alts.addHeart,
		'/lulav-icons/envelope.svg': alts.envelope,
		'/lulav-icons/location.svg': alts.siteMap.locations,
		'/lulav-icons/purim-icon.svg': alts.steps.mishloachManot
	}

	return (
		<Dialog fullScreen transitionDuration={0} id='material-popup' open={isOpen} >
			<div id='popup' style={{ direction }}>
				<div className='icon' >
					<img height='100%' width='100%' src={imagePath} alt={imagePathsAndAlts[imagePath as keyof typeof imagePathsAndAlts]} />
				</div>
				<div className='title' >{title}</div>
				<div className='text' >{text}</div>
				{button ? <Button onClick={() => { if (typeof button.onClick === 'function') button.onClick() }}>{button.text}</Button> : null}
			</div>
			<Footer showShoppingCart={false} />
		</Dialog>
	);
}

export default FullPagePopup;